<template>

  <div class="wrapper">

    <div class="header">

      <div class="logo">
        <img src="@/assets/signup.log.png" @click="backIndex">
      </div>

      <div class="header-right">


      </div>

    </div>
    <div class="main">

      <div class="main-right">

        <div class="head">

          忘记密码

        </div>

        <div>

          <div class="sub-header">
            手机号码
            <el-input v-model="telPhone" placeholder="请输入手机号" @blur="warnPhoneText()" maxlength="11"
                      @keyup.enter.native="phoneEnterFun"></el-input>
          </div>

          <div class="sub-header">
            手机验证码
            <el-input v-model="checkCode" placeholder="请输入验证码" @blur="checkSmsCode($event)" maxlength="6"
                      @keyup.enter.native="checkCodeEnterFun">
              <el-button size="medium" slot="append" v-show="!showTime" @click="sendSMS($event)">
                发送验证码
              </el-button>
              <el-button size="medium" slot="append" v-show="showTime">{{ sendTime }}秒</el-button>
            </el-input>
          </div>


          <div class="sub-header">
            新密码
            <el-input v-model="password" placeholder="请输入新的登陆密码" @blur="checkPassword($event.target.value)"
                      @keyup.enter.native="passwordEnterFun" show-password :disabled="disable">
            </el-input>
          </div>
          <div class="sub-header">
            确认新密码
            <el-input v-model="duplicatePassword" placeholder="请确认新的登陆密码"
                      @blur="checkDuplicatePassword()"
                      @keyup.enter.native="checkDuplicatePasswordEnterFun" maxlength="30" show-password
                      :disabled="disable">
            </el-input>
          </div>

          <div class="sub-header">
            <div class="blue-button" @click="submit">
              确认修改
            </div>
          </div>

        </div>

      </div>


    </div>

  </div>


</template>

<script>

import {getCheckCode, forgetPwd, checkAccountRegister, checkPhoneRegister} from '../api/userMG.js'
import md5 from 'js-md5';

export default {
  name: "signup",
  data: () => {
    return {
      checkCode: "",
      password: "",
      telPhone: "",
      checked: false,
      account: "",
      disable: true,
      showTime: false, /* 布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */
      sendTime: '', /* 倒计时 计数器 */
      timer: null,
      duplicatePassword: ""
    }
  },
  mounted() {
  },
  methods: {
    backIndex() {
      window.location.href = "http://ubiboat.powerlbs.com"
    },
    warnPhoneText() {
      if (!this.checkPhone(this.telPhone)) {
        this.$message.warning("请输入正确手机号");
      }
      let that = this;
      checkPhoneRegister(this.telPhone).then(function (response) {

        if (response.status != 200) {
          that.$message.warning(response.message);
        } else {
          if (!response.data) {
            that.$message.warning("手机号未注册");
          }
        }
        console.log(response);
      }).catch(function (error) {
        console.log(error)
        that.$message.warning("网络错误,请稍后再试!");
      });
    },
    sendSMS() {
      if (!this.checkPhone(this.telPhone)) {
        this.$message.warning("请输入正确手机号");
      } else {

        getCheckCode(this.telPhone);
        this.$notify({
          title: '成功',
          message: '短信已发送',
          type: 'success'
        });

        const TIME_COUNT = 60; //  更改倒计时时间
        if (!this.timer) {
          this.sendTime = TIME_COUNT;
          this.showTime = true;
          this.timer = setInterval(() => {
            if (this.sendTime > 0 && this.sendTime <= TIME_COUNT) {
              this.sendTime--;
            } else {
              this.showTime = false;
              clearInterval(this.timer); // 清除定时器
              this.timer = null;
            }
          }, 1000);
        }

      }

    },
    phoneEnterFun(e) {
      const keyCode = window.event ? e.keyCode : e.which;

      if (keyCode == 13 && this.telPhone) {
        this.warnPhoneText();
      }
    },

    accountEnterFun(e) {
      const keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.checkCode) {
        this.checkAccount(this.account);
      }
    },

    checkCodeEnterFun(e) {
      const keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.checkCode) {
        this.checkSmsCode(e);
      }
    },

    passwordEnterFun(e) {
      const keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.password) {
        this.checkPassword(this.password);
      }
    },

    checkDuplicatePasswordEnterFun(e) {
      const keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.checkDuplicatePassword();
      }
    },


    checkSmsCode(e) {
      if (!this.checkPhone(this.telPhone)) {
        this.$message.warning("请输入正确手机号");
      } else {
        this.disable = false;
        // const code = e.target.value;
        // if (code == '123456') {
        //
        // } else {
        //   this.$message.warning("请输入正确的验证码");
        // }

      }
    },

    checkPhone(num) {
      return /^1[3456789]\d{9}$/.test(num);
    },
    checkAccount(account) {

      if (!/^\w{6,18}$/.test(account)) {
        this.$message.warning("账号由字母、数字、下划线组成，6-18位");
      }

      let that = this;
      checkAccountRegister(this.account).then(function (response) {

        if (response.status != 200) {
          that.$message.warning(response.message);
        } else {
          if (response.data) {
            that.$message.warning("账号已注册");
          }
        }
        console.log(response);
      }).catch(function (error) {
        console.log(error)
        that.$message.warning("网络错误,请稍后再试!");
      });

    },

    checkPassword(password) {

      const pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}');
      if (!pwdRegex.test(password)) {
        this.$message.warning("密码中必须包含字母、数字、特称字符，至少8个字符，最多30个字符");
      }
    },

    checkDuplicatePassword() {

      if (this.password != this.duplicatePassword) {
        this.$message.warning("两次输入密码不一致");
      }
    },

    submit() {
      let that = this;
      if (this.checkCode && this.password && this.telPhone) {
        forgetPwd(
          {
            "account": this.account,
            "smsCode": this.checkCode,
            "pwd": md5(this.password),
            "phoneNum": this.telPhone
          }
        ).then(function (response) {

          if (response.status != 200) {
            that.$message.warning(response.message);
          } else {

            that.$confirm('密码修改成功是否立即登陆？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'success'
            }).then(() => {
              that.$router.push("login")
            }).catch(() => {

            });
            console.log(response);
          }

        }).catch(function (error) {
          console.log(error)
          that.$message.error("网络错误,请稍后再试!");
        });

      } else {
        that.$message.warning("信息校验错误，请检查您的提交信息！")
      }


    }

  }

}


</script>


<style scoped>


a:link {
  color: #099dfd
}

a:visited {
  color: #099dfd
}


a:hover {
  color: #099dfd
}

a:active {
  color: #099dfd
}

/*包含以下四种的链接*/
a {
  text-decoration: #099dfd;
}

/*正常的未被访问过的链接*/
a:link {
  text-decoration: #099dfd;
}

/*已经访问过的链接*/
a:visited {
  text-decoration: #099dfd;
}

/*鼠标划过(停留)的链接*/
a:hover {
  text-decoration: #099dfd;
}

/* 正在点击的链接*/
a:active {
  text-decoration: #099dfd;
}


.header {
  display: flex;
  justify-content: space-between;
  height: 10vh;
  background-color: #ffffff;
  align-items: center;
  box-shadow: 0 0.01vw 0.01vw 0 rgb(0 0 0 / 15%);
  padding: 0 5vw
}


.header-right {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tips {
  color: #4f4f4f;
}

.blue-button {
  background-color: #429df6;
  color: #ffffff;
  text-align: center;
  width: 5.5vw;
  height: 2vw;
  line-height: 2vw;
  border-radius: 0.3vw;
  cursor: pointer;

}


.main {
  display: flex;
  justify-content: center;
  height: 90vh;
}

.main-right {
  width: 50vw;
  background-color: #ffffff;
}

.main-left {
  width: 50vw;
  background-color: #f9f9fc;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.icon-list {
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-list img {
  width: 9vw;
  padding: 0 1vw;
}


.main-left .title {
  margin: 3vw 0;

  font-size: 2vw;
  color: black;
  font-weight: 400;

}

.main-left .title span {
  color: #429df6;
}

.main-left .content {
  color: #4f4f4f;
  margin-bottom: 2vw;

}

.main-right {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sub-header {
  margin-top: 2vw;
  width: 30vw;
}

.main-right .head {
  font-size: 2vw;
  color: black;
}

.protocol {
  margin-top: 2.5vw;
  margin-bottom: 2vw;
}


.main-right .blue-button {
  width: 100%;
  height: 2.5vw;
  line-height: 2.5vw;
}

.logo img {
  cursor: pointer;
  width: 20vw;
}


</style>



// WEBPACK FOOTER //
// src/views/Forget.vue